import StyledIllustration from "./StyledIllustration";

interface NoPlaylistsIllustrationProps {
    width?: number;
    height?: number;
}

export const NoPlaylistsIllustration = (props: NoPlaylistsIllustrationProps) => {
    const { width = 300, height = 300 } = props;

    return (
        <StyledIllustration
            fileName={"NoPlaylists.svg"}
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 300 300"
        >
            <path
                d="M40.293 154.268C40.293 149.85 43.8747 146.268 48.293 146.268H184.293C188.711 146.268 192.293 149.85 192.293 154.268V198.768V243.268C192.293 247.687 188.711 251.268 184.293 251.268H48.293C43.8747 251.268 40.293 247.687 40.293 243.268V154.268Z"
                className="Tone1"
                fill="#333333"
            />
            <path d="M62 232.97H172" className="sTone8" stroke="white" strokeWidth="2" strokeLinecap="round" />
            <circle
                cx="116.417"
                cy="193.258"
                r="21.6755"
                transform="rotate(-5.3899 116.417 193.258)"
                className="Primary"
                fill="#006EFA"
            />
            <path
                d="M124.847 191.173C126.453 192.1 126.453 194.417 124.847 195.344L114.01 201.601C112.404 202.528 110.397 201.37 110.397 199.516L110.397 187.001C110.397 185.147 112.404 183.989 114.01 184.916L124.847 191.173Z"
                className="Tone8"
                fill="white"
            />
            <rect
                x="154"
                y="66"
                width="93.757"
                height="121"
                rx="8"
                className="Tone8 sTone1"
                fill="white"
                stroke="#333333"
                strokeWidth="2"
            />
            <path
                d="M272 156.5C272 148.492 265.508 142 257.5 142L194.5 142C186.492 142 180 148.492 180 156.5C180 164.508 186.492 171 194.5 171H257.5C265.508 171 272 164.508 272 156.5Z"
                className="Primary"
                fill="#006EFA"
            />
            <path
                d="M195.922 161.266C197.815 161.264 199.705 160.94 201.477 160.289C203.769 159.447 205.931 157.998 207.063 155.861C208.197 153.725 209.195 150.835 206.394 150.554C203.725 150.444 203.231 154.129 204.342 156.726C205.452 159.323 208.383 161.028 211.22 160.767C213.157 160.592 214.932 159.657 216.594 158.667C217.959 157.85 218.538 157.305 221.545 155.408C222.479 154.819 223.51 154.308 224.618 154.223C227.338 154.015 229.325 156.555 231.373 158.342C234.255 160.856 238.17 162.174 241.996 161.92C243.982 162.017 248.775 161.175 252.058 157.028"
                className="sTone8"
                stroke="white"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <ellipse cx="165.152" cy="77.0452" rx="3.71739" ry="3.68174" className="Primary" fill="#006EFA" />
            <ellipse cx="177.544" cy="77.0452" rx="3.71739" ry="3.68174" className="Tone1" fill="#333333" />
            <path
                d="M189.935 74.3635C191.444 74.3637 192.651 75.5733 192.651 77.0451C192.651 78.517 191.444 79.7266 189.935 79.7268C188.425 79.7268 187.217 78.5172 187.217 77.0451C187.217 75.5732 188.425 74.3635 189.935 74.3635Z"
                className="sTone1"
                stroke="#333333"
                strokeWidth="2"
            />
            <path d="M179.065 94H229.305" className="sTone1" stroke="#333333" strokeWidth="2" strokeLinecap="round" />
            <path d="M170.391 110H215.673" className="sTone1" stroke="#333333" strokeWidth="2" strokeLinecap="round" />
            <path d="M195.174 126H229.304" className="sTone1" stroke="#333333" strokeWidth="2" strokeLinecap="round" />
            <rect
                width="56.5158"
                height="42.6534"
                rx="21.3267"
                transform="matrix(-0.999967 0.00813106 0.00813103 0.999967 126.283 69.6479)"
                className="Primary"
                fill="#006EFA"
            />
            <path
                d="M112.082 116.771L95.3896 102.174L113.389 102.028L113.504 116.119C113.51 116.858 112.639 117.258 112.082 116.771Z"
                className="Primary"
                fill="#006EFA"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M97.6459 87.615C97.6459 87.615 94.7387 83.2717 91.1256 84.0545C87.5124 84.8373 85.6434 89.493 88.1103 93.2603C90.3434 96.6706 96.4991 100.696 98.1412 101.288C98.3131 101.35 98.5326 101.349 98.7645 101.273C103.556 99.7098 106.525 96.1631 108.322 93.0959C108.322 93.0959 111.152 87.3555 106.404 84.5906C101.656 81.8257 97.6459 87.615 97.6459 87.615Z"
                className="Tone8"
                fill="white"
            />
        </StyledIllustration>
    );
};
